import React from "react";
import { createRoot } from "react-dom/client";
import { PostHogProvider } from '@posthog/react';
import App from "./App.tsx";
import "./index.css";

const posthogOptions = {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  capture_pageview: false,   // We handle SPA page views manually via PostHogPageView
  capture_pageleave: true,
  autocapture: true,          // Auto-track clicks on a/button/form/input/select/textarea/label
  capture_exceptions: true,   // Auto-capture window.onerror + unhandledrejection
  disable_session_recording: true,
} as const;

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider apiKey={import.meta.env.VITE_POSTHOG_KEY} options={posthogOptions}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);
